import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center py-10"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger mb-4"
}
const _hoisted_4 = {
  key: 2,
  class: "widget mb-6",
  style: {"display":"flex","align-items":"center","gap":"1.25rem","padding":"1.25rem 1.5rem"}
}
const _hoisted_5 = { style: {"width":"64px","height":"64px","min-width":"64px","flex":"0 0 64px","border-radius":"50%","overflow":"hidden"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"flex":"1 1 0","min-width":"0"} }
const _hoisted_8 = {
  class: "mb-1",
  style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_9 = { class: "text-sm text-grey-700 m-0" }
const _hoisted_10 = { style: {"flex":"0 0 auto","display":"flex","flex-direction":"column","gap":"0.5rem","align-items":"flex-start"} }
const _hoisted_11 = { class: "text-sm font-medium" }
const _hoisted_12 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_13 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_14 = { style: {"flex":"1 1 200px","min-width":"200px"} }
const _hoisted_15 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_16 = {
  class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
  style: {"width":"100%"}
}
const _hoisted_17 = {
  key: 3,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_18 = {
  key: 4,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_19 = {
  key: 5,
  class: "s20 widget px-6 pt-8 pb-2 mb-6"
}
const _hoisted_20 = { class: "s10 mt--5-5 flex-right gap-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_23 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content active" }
const _hoisted_24 = {
  key: 0,
  class: "rounded-30 mt-3 mb-6",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.04)","padding":"1.5rem"}
}
const _hoisted_25 = { style: {"display":"grid","grid-template-columns":"repeat(auto-fit, minmax(220px, 1fr))","gap":"0.75rem"} }
const _hoisted_26 = { class: "flex-right mt-4" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "s20 flex gap-5" }
const _hoisted_29 = { class: "s7_mobile px-6" }
const _hoisted_30 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_31 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_32 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_33 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_34 = { class: "text-grey-900 my-2" }
const _hoisted_35 = { class: "text-grey-900 my-2" }
const _hoisted_36 = {
  key: 0,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_37 = { class: "text-grey-800" }
const _hoisted_38 = { class: "mb-2 text-grey-800" }
const _hoisted_39 = { class: "s7_mobile px-6" }
const _hoisted_40 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_41 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_42 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_43 = {
  key: 0,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_44 = {
  key: 1,
  class: "font-normal my-2 text-grey-500"
}
const _hoisted_45 = {
  key: 2,
  class: "text-grey-800"
}
const _hoisted_46 = {
  key: 6,
  class: "s20 widget px-6 pt-8 pb-2"
}
const _hoisted_47 = { class: "s20 gap-6 px-4 pb-6 collapse-content active" }
const _hoisted_48 = { class: "s20 flex gap-3 mb-2" }
const _hoisted_49 = { class: "form-field-split my-4" }
const _hoisted_50 = { class: "form-field-floating reactive search sm" }
const _hoisted_51 = { class: "form-field-split my-4" }
const _hoisted_52 = { class: "form-field-floating reactive sm" }
const _hoisted_53 = { class: "form-field-floating reactive sm" }
const _hoisted_54 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_55 = {
  key: 1,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_56 = {
  key: 2,
  class: "s20"
}
const _hoisted_57 = { class: "s13 mt-2" }
const _hoisted_58 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_59 = { class: "secondary-font text-sm text-grey-600 mb-2" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "pagination sm justify-content-left mt-5" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = { class: "page-link active" }
const _hoisted_64 = ["disabled"]

import { ref, onMounted, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import membersService from '@/services/membersService'
import { showAlert, showConfirm } from '@/utils/swal'

interface Member {
  id: number
  nom: string
  prenom: string
  collectivite?: { id: number; nom: string }
  photo?: string
  photo_url?: string
  email?: string
  telephone?: string
  actif?: number
}

interface Carte {
  id: number
  alias: string | null
  numero_masque: string | null
  bloc4: string | null
  type: string | null
  statut: string
  solde: number
  expiration_mois: number | null
  expiration_annee: number | null
  reference: string | null
  num_lot: string | null
  date_retrait: string | null
  created_at: string | null
  par_defaut: boolean
  banque: { id: number; nom: string; slug: string } | null
}

interface Transaction {
  id: number
  reference: string | null
  libelle: string | null
  description: string | null
  montant: number
  devise: string | null
  type: string
  statut: string
  categorie_slug: string | null
  created_at: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectiviteMembreCarte',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const member = ref<Member | null>(null)
const loading = ref(false)
const errorMessage = ref('')

const cartes = ref<Carte[]>([])
const cartesLoading = ref(false)
const selectedCarteId = ref<number | null>(null)

const transactions = ref<Transaction[]>([])
const transactionsTotal = ref(0)
const transactionsLoading = ref(false)
const txPage = ref(1)
const txPerPage = ref(25)
const txReference = ref('')
const txDateMin = ref('')
const txDateMax = ref('')

const blocking = ref(false)
const retraitForm = ref({
  telephone: '',
  nom: '',
  prenom: '',
  numero_piece: '',
  bloc4: '',
  code_retrait: '',
})
const retraitLoading = ref(false)

const selectedCarte = computed<Carte | null>(() => {
  return cartes.value.find(c => c.id === selectedCarteId.value) || cartes.value[0] || null
})

watch(selectedCarte, (carte) => {
  if (carte?.bloc4) {
    retraitForm.value.bloc4 = `**** **** **** ${carte.bloc4}`
  } else {
    retraitForm.value.bloc4 = ''
  }
})

const totalPages = computed(() => Math.ceil(transactionsTotal.value / txPerPage.value) || 1)

onMounted(async () => {
  const memberId = route.params.id
  if (!memberId) {
    router.push({ name: 'collectivites-membres' })
    return
  }
  await loadMember(Number(memberId))
  await loadCartes(Number(memberId))
})

async function loadMember(id: number) {
  try {
    loading.value = true
    errorMessage.value = ''
    const data = await membersService.getMember(id)
    member.value = data
    retraitForm.value.nom = data?.nom || ''
    retraitForm.value.prenom = data?.prenom || ''
    const kycDocs = (data as any)?.kyc?.kyc_documents || []
    const idDoc = kycDocs.find((d: any) => d?.type_document === 'cni_recto' || d?.type_document === 'passeport')
    retraitForm.value.numero_piece = idDoc?.numero || (data as any)?.numero_piece_identite || ''
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors du chargement du membre'
  } finally {
    loading.value = false
  }
}

async function loadCartes(memberId: number) {
  cartesLoading.value = true
  try {
    const data = await membersService.getMemberCartes(memberId)
    cartes.value = data.cartes || []
    if (cartes.value.length > 0 && selectedCarteId.value === null) {
      selectedCarteId.value = cartes.value[0].id
      await loadTransactions()
    }
  } catch (error: any) {
    console.error('Erreur chargement cartes:', error)
  } finally {
    cartesLoading.value = false
  }
}

async function loadTransactions() {
  if (!member.value || !selectedCarte.value) return
  transactionsLoading.value = true
  try {
    const data = await membersService.getMemberCarteTransactions(
      member.value.id,
      selectedCarte.value.id,
      {
        reference: txReference.value || undefined,
        date_min: txDateMin.value || undefined,
        date_max: txDateMax.value || undefined,
        page: txPage.value,
        per_page: txPerPage.value,
      },
    )
    transactions.value = data.data || []
    transactionsTotal.value = data.total || 0
  } catch (error: any) {
    console.error('Erreur chargement transactions:', error)
  } finally {
    transactionsLoading.value = false
  }
}

async function bloquerCarte() {
  if (!member.value || !selectedCarte.value || blocking.value) return
  const confirmation = await showConfirm(
    'Voulez-vous vraiment bloquer cette carte ?',
    'Confirmation de blocage',
  )
  if (!confirmation) return

  blocking.value = true
  try {
    await membersService.bloquerMemberCarte(member.value.id, selectedCarte.value.id)
    await loadCartes(member.value.id)
    await showAlert.success('Carte bloquée avec succès.', 'Blocage réussi')
  } catch (error: any) {
    await showAlert.error(error.message || 'Erreur lors du blocage.', 'Erreur')
  } finally {
    blocking.value = false
  }
}

async function retraitCarte() {
  if (!member.value || !selectedCarte.value || retraitLoading.value) return
  if (!retraitForm.value.bloc4 || !retraitForm.value.code_retrait || !retraitForm.value.telephone) {
    await showAlert.error('Le téléphone, les 4 derniers chiffres et le code de retrait sont obligatoires.', 'Champs manquants')
    return
  }
  retraitLoading.value = true
  try {
    const bloc4Clean = retraitForm.value.bloc4.replace(/\D/g, '').slice(-4)
    await membersService.retraitMemberCarte(member.value.id, selectedCarte.value.id, {
      bloc4: bloc4Clean,
      code_retrait: retraitForm.value.code_retrait,
      telephone: retraitForm.value.telephone,
    })
    await showAlert.success('Carte retirée avec succès.', 'Retrait réussi')
    retraitForm.value = { telephone: '', nom: '', prenom: '', numero_piece: '', bloc4: '', code_retrait: '' }
    await loadCartes(member.value.id)
  } catch (error: any) {
    await showAlert.error(error.message || 'Erreur lors du retrait.', 'Erreur')
  } finally {
    retraitLoading.value = false
  }
}

function applyTxFilters() {
  txPage.value = 1
  loadTransactions()
}

function changePage(page: number) {
  if (page < 1 || page > totalPages.value) return
  txPage.value = page
  loadTransactions()
}

function goBack() {
  if (member.value) {
    router.push({ name: 'collectivites-membre-detail', params: { id: member.value.id } })
  } else {
    router.push({ name: 'collectivites-membres' })
  }
}

function formatAmount(amount: number): string {
  return new Intl.NumberFormat('fr-FR').format(amount || 0)
}

function formatDateLong(dateString: string | null): string {
  if (!dateString) return '-'
  const monthsFr = ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc']
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return '-'
  const hh = String(date.getHours()).padStart(2, '0')
  const mm = String(date.getMinutes()).padStart(2, '0')
  return `${String(date.getDate()).padStart(2, '0')} ${monthsFr[date.getMonth()]} ${date.getFullYear()} ${hh}:${mm}`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", { class: "d-flex align-items-center gap-4 mb-6" }, [
      _createElementVNode("button", {
        class: "btn white2",
        onClick: goBack
      }, [...(_cache[11] || (_cache[11] = [
        _createElementVNode("img", {
          src: "/public/icons/icon-back.svg",
          class: "btn-icon",
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "Retour", -1)
      ]))]),
      _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-0" }, "Membre - Carte", -1))
    ]),
    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: member.value.photo_url ? member.value.photo_url : '/public/assets/users/300w/user2.jpg',
              style: {"width":"100%","height":"100%","object-fit":"cover","display":"block"}
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h4", _hoisted_8, _toDisplayString(member.value.email || member.value.telephone || 'N/A'), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(member.value.nom) + " " + _toDisplayString(member.value.prenom), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(member.value.collectivite?.nom || 'N/A'), 1),
            (member.value.actif)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Actif"))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, "Inactif"))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Solde", -1)),
              _createElementVNode("div", _hoisted_16, _toDisplayString(selectedCarte.value ? formatAmount(selectedCarte.value.solde) + ' F' : '-'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (cartesLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Chargement des cartes..."))
      : (cartes.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Aucune carte associée à ce membre. "))
        : (selectedCarte.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }, [
                _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-panel-open.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-open",
                    alt: ""
                  }),
                  _createElementVNode("img", {
                    src: "/public/icons/icon-panel-close.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-close",
                    alt: ""
                  }),
                  _createTextVNode(" Carte ")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_20, [
                (selectedCarte.value.statut !== 'blocked')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-ultra lg shadow-200 color2",
                      disabled: blocking.value,
                      onClick: bloquerCarte
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["btn-show", { 'display-none': blocking.value }])
                      }, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("img", {
                          src: "/public/icons/icon-consulter.svg",
                          class: "btn-icon",
                          alt: ""
                        }, null, -1),
                        _createElementVNode("span", null, "Bloquer", -1)
                      ]))], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["btn-loading", { 'display-none': !blocking.value }])
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("div", { class: "loader-dots" }, null, -1)
                      ]))], 2)
                    ], 8, _hoisted_21))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, "Bloquée"))
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
              _createElementVNode("div", _hoisted_23, [
                (selectedCarte.value.statut === 'delivery')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "mb-4" }, "Retrait de carte", -1)),
                      _createElementVNode("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((retraitForm.value.telephone) = $event)),
                          type: "text",
                          class: "retrait-input",
                          placeholder: "Numéro de téléphone du membre"
                        }, null, 512), [
                          [_vModelText, retraitForm.value.telephone]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((retraitForm.value.numero_piece) = $event)),
                          type: "text",
                          class: "retrait-input",
                          placeholder: "Numéro de la pièce d'identité"
                        }, null, 512), [
                          [_vModelText, retraitForm.value.numero_piece]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((retraitForm.value.nom) = $event)),
                          type: "text",
                          class: "retrait-input",
                          placeholder: "Nom"
                        }, null, 512), [
                          [_vModelText, retraitForm.value.nom]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((retraitForm.value.bloc4) = $event)),
                          type: "text",
                          class: "retrait-input",
                          placeholder: "Les 4 derniers chiffres de la carte",
                          maxlength: "4"
                        }, null, 512), [
                          [_vModelText, retraitForm.value.bloc4]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((retraitForm.value.prenom) = $event)),
                          type: "text",
                          class: "retrait-input",
                          placeholder: "Prénom"
                        }, null, 512), [
                          [_vModelText, retraitForm.value.prenom]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((retraitForm.value.code_retrait) = $event)),
                          type: "text",
                          class: "retrait-input",
                          placeholder: "Code de retrait de la carte"
                        }, null, 512), [
                          [_vModelText, retraitForm.value.code_retrait]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("button", {
                          class: "btn-ultra",
                          style: {"white-space":"nowrap","min-width":"180px"},
                          disabled: retraitLoading.value,
                          onClick: retraitCarte
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["btn-show", { 'display-none': retraitLoading.value }]),
                            style: {"white-space":"nowrap"}
                          }, [...(_cache[17] || (_cache[17] = [
                            _createElementVNode("img", {
                              src: "/public/icons/icon-valider.svg",
                              class: "btn-icon",
                              alt: ""
                            }, null, -1),
                            _createElementVNode("span", { style: {"white-space":"nowrap"} }, "Valider le retrait", -1)
                          ]))], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["btn-loading", { 'display-none': !retraitLoading.value }])
                          }, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("div", { class: "loader-dots" }, null, -1)
                          ]))], 2)
                        ], 8, _hoisted_27)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "s6_mobile" }, [
                    _createElementVNode("img", {
                      src: "/public/images/carte_coop.png",
                      alt: "Carte",
                      width: "100%",
                      class: "rounded-30"
                    })
                  ], -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "flex-center" }, [
                    _createElementVNode("hr", { class: "hr-vertical h-100p" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("h3", _hoisted_30, [
                      _cache[20] || (_cache[20] = _createTextVNode(" Carte   ", -1)),
                      (selectedCarte.value.statut === 'active')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Validé"))
                        : (selectedCarte.value.statut === 'blocked')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Bloquée"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(selectedCarte.value.statut), 1))
                    ]),
                    _createElementVNode("h4", _hoisted_34, "**** **** **** " + _toDisplayString(selectedCarte.value.bloc4 || '****'), 1),
                    _createElementVNode("h4", _hoisted_35, _toDisplayString(selectedCarte.value.banque?.nom || 'N/A'), 1),
                    (selectedCarte.value.created_at)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_36, " Créé le " + _toDisplayString(formatDateLong(selectedCarte.value.created_at)), 1))
                      : _createCommentVNode("", true),
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
                    _createElementVNode("h4", _hoisted_37, "Référence / " + _toDisplayString(selectedCarte.value.reference || '-'), 1),
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Solde disponible", -1)),
                    _createElementVNode("h4", _hoisted_38, _toDisplayString(formatAmount(selectedCarte.value.solde)) + " F", 1)
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "flex-center" }, [
                    _createElementVNode("hr", { class: "hr-vertical h-100p" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("h3", _hoisted_40, [
                      _cache[24] || (_cache[24] = _createTextVNode("Retrait   ", -1)),
                      (selectedCarte.value.date_retrait)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Effectué"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_42, "En attente"))
                    ]),
                    (selectedCarte.value.date_retrait)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_43, " Retiré le " + _toDisplayString(formatDateLong(selectedCarte.value.date_retrait)), 1))
                      : (_openBlock(), _createElementBlock("h5", _hoisted_44, "Carte non encore retirée")),
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
                    (selectedCarte.value.num_lot)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_45, "N° de lot : " + _toDisplayString(selectedCarte.value.num_lot), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
    (selectedCarte.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _cache[39] || (_cache[39] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\" data-v-5f07998c><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\" data-v-5f07998c><img src=\"/public/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\" data-v-5f07998c><img src=\"/public/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\" data-v-5f07998c> Transactions </span></div><div class=\"clear-both h-5\" data-v-5f07998c></div>", 2)),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((txReference).value = $event)),
                    type: "text",
                    class: "form-input",
                    name: "reference",
                    id: "reference",
                    placeholder: "",
                    onKeyup: _withKeys(applyTxFilters, ["enter"])
                  }, null, 544), [
                    [_vModelText, txReference.value]
                  ]),
                  _cache[31] || (_cache[31] = _createElementVNode("label", { for: "reference" }, "Référence de transaction", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((txDateMin).value = $event)),
                    type: "date",
                    class: "form-input",
                    name: "date_min",
                    id: "date_min",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, txDateMin.value]
                  ]),
                  _cache[32] || (_cache[32] = _createElementVNode("label", { for: "date_min" }, "Date >=", -1))
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("hr", { class: "hr sm" }, null, -1)),
                _createElementVNode("div", _hoisted_53, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((txDateMax).value = $event)),
                    type: "date",
                    class: "form-input",
                    name: "date_max",
                    id: "date_max",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, txDateMax.value]
                  ]),
                  _cache[33] || (_cache[33] = _createElementVNode("label", { for: "date_max" }, "Date <=", -1))
                ])
              ]),
              _createElementVNode("button", {
                class: "btn lg shadow-200 color2",
                onClick: applyTxFilters
              }, [...(_cache[35] || (_cache[35] = [
                _createElementVNode("span", null, "Filtrer", -1)
              ]))])
            ]),
            (transactionsLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, " Chargement des transactions... "))
              : (transactions.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, " Aucune transaction trouvée pour cette carte. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (tx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: tx.id,
                        class: "flex gap-6 mb-4"
                      }, [
                        _cache[36] || (_cache[36] = _createElementVNode("div", {
                          class: "square-xl px-4 py-4",
                          style: {"background-color":"rgba(0, 185, 172, 0.08)"}
                        }, [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-trans-recharger.svg",
                            width: "100%",
                            class: "icon-neutral"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("h6", _hoisted_58, _toDisplayString(tx.libelle || tx.description || tx.reference || '-'), 1),
                          _createElementVNode("p", _hoisted_59, [
                            _createTextVNode(_toDisplayString(formatDateLong(tx.created_at)) + " ", 1),
                            (tx.reference)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_60, " - " + _toDisplayString(tx.reference), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("h5", {
                          class: _normalizeClass(["s5 secondary-font text-right mt-2", { 'text-green': tx.type === 'credit' }])
                        }, _toDisplayString(tx.type === 'credit' ? '+ ' : '- ') + _toDisplayString(formatAmount(tx.montant)) + " F ", 3)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("button", {
                        class: "page-link",
                        disabled: txPage.value === 1,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (changePage(txPage.value - 1)))
                      }, [...(_cache[37] || (_cache[37] = [
                        _createElementVNode("img", {
                          src: "/public/icons/icon-pagination-prev.svg",
                          class: "pagination-icon",
                          alt: ""
                        }, null, -1),
                        _createTextVNode(" Précedent ", -1)
                      ]))], 8, _hoisted_62),
                      _createElementVNode("span", _hoisted_63, _toDisplayString(txPage.value) + " / " + _toDisplayString(totalPages.value), 1),
                      _createElementVNode("button", {
                        class: "page-link pl-4",
                        disabled: txPage.value >= totalPages.value,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (changePage(txPage.value + 1)))
                      }, [...(_cache[38] || (_cache[38] = [
                        _createTextVNode(" Suivant ", -1),
                        _createElementVNode("img", {
                          src: "/public/icons/icon-pagination-next.svg",
                          class: "pagination-icon ml-2",
                          alt: ""
                        }, null, -1)
                      ]))], 8, _hoisted_64)
                    ])
                  ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})